module.exports = __webpack_public_path__ + "static/media/background-logo-grey.dd526082.svg";